module.exports = __webpack_public_path__ + "images/d7d1c72b1c937ec85aa86c7546a663e5-wood0.jpg";